// MANISH CUSTOM CODE - COLLECTION PRODUCT GRID (manish-cc) - START
// Button text feedback ("Adding..." / "Added") for the Add to cart buttons in
// sections/manish-cc-collection-grid.liquid. The add itself is done by the
// theme's own <product-form-component>, which also opens the cart drawer.
// Only elements marked data-mm-cg-* are touched, so no other section is
// affected. Safe to load more than once (registers its listeners once).

if (!window.__mmCgReady) {
  window.__mmCgReady = true;

  var resetTimers = new WeakMap();

  var setButtonState = function (button, state) {
    var text = button.dataset.textIdle;
    if (state === 'adding') text = button.dataset.textAdding || text;
    if (state === 'added') text = button.dataset.textAdded || text;

    button.textContent = text;
    button.dataset.state = state;
    button.disabled = state === 'adding';

    var timer = resetTimers.get(button);
    if (timer) window.clearTimeout(timer);

    if (state === 'added' || state === 'error') {
      resetTimers.set(button, window.setTimeout(function () { setButtonState(button, 'idle'); }, 1600));
    } else if (state === 'adding') {
      resetTimers.set(button, window.setTimeout(function () { setButtonState(button, 'idle'); }, 8000));
    }
  };

  var buttonIn = function (el) {
    return el && el.querySelector ? el.querySelector('[data-mm-cg-btn]') : null;
  };

  var cartEventsReady = false;

  document.addEventListener('submit', function (event) {
    var form = event.target && event.target.closest ? event.target.closest('[data-mm-cg-form]') : null;
    var button = buttonIn(form);
    if (!button || button.disabled) return;
    setButtonState(button, 'adding');

    if (!cartEventsReady) {
      resetTimers.set(button, window.setTimeout(function () { setButtonState(button, 'idle'); }, 1200));
    }
  });

  var listenForCartResult = function (eventName) {
    cartEventsReady = true;
    document.addEventListener(eventName, function (event) {
      var host = event.target && event.target.closest ? event.target.closest('[data-mm-cg-card-form]') : null;
      var button = buttonIn(host);
      if (!button || !event.promise) return;

      event.promise.then(function (result) {
        var failed = result && result.detail && result.detail.didError;
        setButtonState(button, failed ? 'error' : 'added');
      }).catch(function () {
        setButtonState(button, 'error');
      });
    });
  };

  try {
    import('@shopify/events').then(function (events) {
      if (events && events.StandardEvents && events.StandardEvents.cartLinesUpdate) {
        listenForCartResult(events.StandardEvents.cartLinesUpdate);
      }
    }).catch(function () {});
  } catch (e) {}
}
// MANISH CUSTOM CODE - COLLECTION PRODUCT GRID (manish-cc) - END
